import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import 'react-day-picker/lib/style.css';
import { isValueEntered } from 'services/Validation';
import {
    showPortfolioLoader,
    onSavePortfolio,
    onPortfolioClose,
} from 'actions/portfolio';
import { inputFields, displayedImage, showErrors, modalHeader } from '../common';

const PortfolioEdit = () => {
    const dispatch = useDispatch();
    const editPortfolioState = useSelector(state => state.portfolios.editPortfolioState);
    const portfolio = useSelector(state => state.portfolios.selectedPortfolio);
    const [selectedPortfolio, setSelectedPortfolio] = useState(portfolio);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    // using selectedPortfolio makes it behave like componentDidUpdate - effect takes place when selectedPortfolio changes
    useEffect(() => {
        setSelectedPortfolio(portfolio);
        setFormValid(false);
        validateForm();
        // console.log('portfolio useEffect '.concat(portfolio.name));
    }, [portfolio]);

    // using selectedPortfolio makes it behave like componentDidUpdate - effect takes place when selectedPortfolio changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
        // console.log('selectedPortfolio useEffect '.concat(selectedPortfolio.name));
    }, [selectedPortfolio]);

    const handleUserInput = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        updateSelectedPortfolioField(name, value);
        validateField(name, value);
    };

    const updateSelectedPortfolioField = (fieldName, value) => {
        const newPortfolio = { ...portfolio };
        newPortfolio[fieldName] = value;
        setSelectedPortfolio(newPortfolio);
    };

    const validateField = (fieldName, value) => {
        const valueEntered = isValueEntered(value);
        formErrors[fieldName] = valueEntered ? '' : ' is invalid';
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isValueEntered(selectedPortfolio?.name));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showPortfolioLoader());
                dispatch(onPortfolioClose());
                dispatch(onSavePortfolio(selectedPortfolio));
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onPortfolioClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedPortfolio)}
                        {showErrors(formErrors)}
                        {inputFields(portfolio, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={editPortfolioState}>
            {modalHeader(<IntlMessages id="portfolio.savePortfolio" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="portfolio.savePortfolio" />)}
        </Modal>
    );
};

export default PortfolioEdit;


// WEBPACK FOOTER //
// ./components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js